<script lang="ts" setup>
defineProps<{
  url: string
}>()
</script>

<template>
  <a class="external-link" :href="url" target="_blank" rel="noopener">
    <slot />
    <i class="pi pi-external-link" />
  </a>
</template>

<style lang="scss" scoped>
.external-link {
  color: var(--text-primary);
  font-weight: 700;
  text-decoration: underline;
  text-decoration-thickness: 2px;
  text-underline-offset: 0.2em;

  .pi {
    margin-left: 0.35em;
  }
}
</style>
